import {
  Grid,
  Users,
  Calendar,
  Smile,
  Tag,
  FileText,
  Award,
  CheckCircle,
  AlertTriangle,
  Settings,
  Layers,
  User,
  Coffee,
} from "react-feather";

import {
  GiftOutlined,
  GlobalOutlined,
  WhatsAppOutlined,
  MailOutlined,
  UnorderedListOutlined,
  DoubleRightOutlined,
  ExperimentOutlined,
  SnippetsOutlined,
  AuditOutlined,
} from "@ant-design/icons";

import { AppRoutes } from "../../../../AppRoutes";

export const getBaseMenuItems = (t) => [
  {
    key: AppRoutes.home.key,
    icon: <Grid />,
    label: t("menu.dashboard"),
    route: AppRoutes.home,
  },
  {
    key: AppRoutes.consultantList.key,
    icon: <Users />,
    label: t("menu.consultants"),
    route: AppRoutes.consultantList,
    roles: AppRoutes.consultantList.roles,
  },
  {
    key: "sub1",
    icon: <Award />,
    label: t("menu.followUp"),
    roles: AppRoutes.followUpEventList.roles,
    children: [
      {
        key: AppRoutes.followUpEventMonthlyList.key,
        icon: <Calendar />,
        label: t("menu.monthlyEvents"),
        route: AppRoutes.followUpEventMonthlyList,
        roles: AppRoutes.followUpEventMonthlyList.roles,
      },
      {
        key: AppRoutes.followUpEventList.key,
        icon: <Layers />,
        label: t("menu.listingEvents"),
        route: AppRoutes.followUpEventList,
        roles: AppRoutes.followUpEventList.roles,
      },
      {
        key: AppRoutes.followUpEventStatusList.key,
        icon: <CheckCircle />,
        label: t("menu.doneEvents"),
        route: AppRoutes.followUpEventStatusList,
        roles: AppRoutes.followUpEventStatusList.roles,
      },
      {
        key: AppRoutes.criticalSituationsList.key,
        icon: <AlertTriangle />,
        label: t("menu.criticalSituations"),
        route: AppRoutes.criticalSituationsList,
        roles: AppRoutes.criticalSituationsList.roles,
      },
      {
        key: AppRoutes.welcomeSessionList.key,
        icon: <Coffee />,
        label: t("menu.welcomeSession"),
        route: AppRoutes.welcomeSessionList,
        roles: AppRoutes.welcomeSessionList.roles,
      },
    ],
  },
  {
    key: AppRoutes.consultantAwards.key,
    icon: <Smile />,
    label: t("menu.benefits"),
    route: AppRoutes.consultantAwards,
    roles: AppRoutes.consultantAwards.roles,
  },
  {
    key: AppRoutes.offerList.key,
    icon: <Tag />,
    label: t("menu.offers"),
    route: AppRoutes.offerList,
    roles: AppRoutes.offerList.roles,
  },
  {
    key: AppRoutes.reportList.key,
    icon: <FileText />,
    label: t("menu.reports"),
    route: AppRoutes.reportList,
    roles: AppRoutes.reportList.roles,
  },
  {
    key: "sub3",
    icon: <Settings />,
    label: t("menu.settings"),
    roles: `${AppRoutes.followUpEventTypeList.roles},${AppRoutes.offerTypeList.roles},${AppRoutes.whatsappGroupList.roles},${AppRoutes.quizBuilder.roles},${AppRoutes.emailList.roles},${AppRoutes.templateList.roles},${AppRoutes.techSpecializationList.roles},${AppRoutes.countryList.roles},${AppRoutes.userList.roles}`,
    children: [
      {
        key: AppRoutes.followUpEventTypeList.key,
        icon: <DoubleRightOutlined />,
        label: t("menu.eventTypes"),
        route: AppRoutes.followUpEventTypeList,
        roles: AppRoutes.followUpEventTypeList.roles,
      },
      {
        key: AppRoutes.offerTypeList.key,
        icon: <GiftOutlined />,
        label: t("menu.offerTypes"),
        route: AppRoutes.offerTypeList,
        roles: AppRoutes.offerTypeList.roles,
      },
      {
        key: AppRoutes.certificationTypes.key,
        icon: <SnippetsOutlined />,
        label: t("menu.certificationTypes"),
        route: AppRoutes.certificationTypes,
        roles: AppRoutes.offerTypeList.roles,
      },
      {
        key: AppRoutes.whatsappGroupList.key,
        icon: <WhatsAppOutlined />,
        label: t("menu.whatsappGroups"),
        route: AppRoutes.whatsappGroupList,
        roles: AppRoutes.whatsappGroupList.roles,
      },
      {
        key: AppRoutes.quizBuilder.key,
        icon: <AuditOutlined />,
        label: t("menu.quizBuilder"),
        route: AppRoutes.quizList,
        roles: AppRoutes.quizBuilder.roles,
      },
      {
        key: AppRoutes.emailList.key,
        icon: <MailOutlined />,
        label: t("menu.emails"),
        route: AppRoutes.emailList,
        roles: AppRoutes.emailList.roles,
      },
      {
        key: AppRoutes.templateList.key,
        icon: <UnorderedListOutlined />,
        label: t("menu.templates"),
        route: AppRoutes.templateList,
        roles: AppRoutes.templateList.roles,
      },
      {
        key: AppRoutes.techSpecializationList.key,
        icon: <ExperimentOutlined />,
        label: t("menu.specializations"),
        route: AppRoutes.techSpecializationList,
        roles: AppRoutes.techSpecializationList.roles,
      },
      {
        key: AppRoutes.countryList.key,
        icon: <GlobalOutlined />,
        label: t("menu.countries"),
        route: AppRoutes.countryList,
        roles: AppRoutes.countryList.roles,
      },
      {
        key: AppRoutes.userList.key,
        icon: <User />,
        label: t("menu.users"),
        route: AppRoutes.userList,
        roles: AppRoutes.userList.roles,
      },
    ],
  },
];
